import UnserSortiment from "./slides/UnserSortiment";
import UnsereMarke from "./slides/UnsereMarke";

export default function Work() {
  return [
    <UnsereMarke key="unsere-marke" />,
    <UnserSortiment key="unser-sortiment" />,
  ];
}
